export function clearShards(game) {
  for (const s of game.shards) {
    game._dropHoverMeta.delete(s.mesh);
    game.scene.remove(s.mesh);
  }
  game.shards.length = 0;
}

export function clearAmmoPickups(game) {
  for (const p of game.ammoPickups) {
    game._dropHoverMeta.delete(p.mesh);
    game.scene.remove(p.mesh);
  }
  game.ammoPickups.length = 0;
}

export function clearWeaponPickups(game) {
  for (const p of game.weaponPickups) {
    game._dropHoverMeta.delete(p.mesh);
    game.scene.remove(p.mesh);
  }
  game.weaponPickups.length = 0;
}

export function clearPlayerMines(game) {
  for (const mine of game.playerMines) game.scene.remove(mine.mesh);
  game.playerMines.length = 0;
}
